import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { CustomLink } from '../../../../../common/CustomLink'
import { Icon } from '../../../../../common/html/icon'
import { ThCell } from '../../../../../common/table/ThCell'
import TextEllipsis from '../../../../../common/textEllipsis'
import { COMPONENTS } from '../../../../../routers/constants'
import { changePeerOrganizationIds } from '../../../store/slice'
import { removeOwnershipAndGroup } from '../../ownershipAndGroup/store/slice'
import {
  changeSelectedCompanyList,
  selectSelectedCompanyList,
} from '../../search/popupRecommendationList/store/slice'

export const CustomTHead = ({ tableTitle }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  const onRemoveCompany = (rowId) => () => {
    const filteredCompany = selectedCompanyList.filter(
      (company) => company.id !== +rowId,
    )
    const filteredCompanyListIds = filteredCompany.map((item) => item.id)
    dispatch(removeOwnershipAndGroup(+rowId))
    dispatch(changeSelectedCompanyList(filteredCompany))
    dispatch(changePeerOrganizationIds(filteredCompanyListIds))
  }

  return (
    <tr>
      {tableTitle.map((col, colIndex) => {
        const { title, colId } = col || {}

        const result = {
          ...col,
          isI18n: true,
          thStyle: {
            justifyContent: 'flex-end',
            gap: 0,
          },
          renderTh: () => {
            return (
              <>
                <CustomLink
                  target="_blank"
                  to={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${colId}`}
                >
                  <TextEllipsis
                    zIndexTooltip={7}
                    text={title}
                    isI18n={false}
                    lineClamp={1}
                    className="cursorPointer"
                    appendStyle={{ maxWidth: 150 }}
                  />
                </CustomLink>
                {colId !== 'col1' && colId !== organizationId && (
                  <Icon
                    className="icon-delete"
                    onClick={onRemoveCompany(colId)}
                    style={{
                      color: '#9C9C9C',
                      cursor: 'pointer',
                      paddingLeft: 8,
                    }}
                  />
                )}
              </>
            )
          },
        }

        return <ThCell sticky key={colIndex} col={result} />
      })}
    </tr>
  )
}
